"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "pto-table-cell" };
const _hoisted_2 = { class: "form-label d-flex flex-center" };
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "pto-table-cell" };
const _hoisted_5 = { class: "form-label d-flex flex-center" };
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "pto-table-cell" };
const _hoisted_8 = { class: "form-label d-flex flex-center" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "pto-table-cell" };
const _hoisted_11 = { class: "form-label d-flex flex-center" };
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "pto-table-cell" };
const _hoisted_14 = { class: "form-label d-flex flex-center" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "pto-table-cell" };
const _hoisted_17 = { class: "form-label d-flex flex-center" };
const _hoisted_18 = ["value"];
const _hoisted_19 = { class: "pto-table-cell" };
const _hoisted_20 = { class: "form-label d-flex flex-center" };
const _hoisted_21 = ["value"];
const vue_3 = require("vue");
const common_1 = require("../../common/common");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PtoConfigRow',
    props: {
        ptoConfigDays: {
            type: Object,
            required: true
        }
    },
    emits: ["configParams"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const configLocal = (0, vue_3.ref)({ ...props.ptoConfigDays });
        function emitData(key, e) {
            const target = e.target;
            const value = (0, common_1.fullWidthToAscii)(target.value);
            configLocal.value[key] = parseInt(value) || 0;
            emit("configParams", configLocal);
        }
        function emitHalfData(e) {
            emitData("halfYear", e);
        }
        function emitOneHalfData(e) {
            emitData("oneAndHalfYear", e);
        }
        function emitTwoHalfData(e) {
            emitData("twoAndHalfYears", e);
        }
        function emitThreeHalfData(e) {
            emitData("threeAndHalfYears", e);
        }
        function emitFourHalfData(e) {
            emitData("fourAndHalfYears", e);
        }
        function emitFiveHalfData(e) {
            emitData("fiveAndHalfYears", e);
        }
        function emitSixHalfData(e) {
            emitData("sixAndHalfYears", e);
        }
        function updateConfigDays() {
            configLocal.value = { ...props.ptoConfigDays };
        }
        (0, vue_3.watch)(props.ptoConfigDays, () => {
            updateConfigDays();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("label", _hoisted_2, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitHalfData,
                            value: configLocal.value.halfYear
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
                        _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createElementVNode)("label", _hoisted_5, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitOneHalfData,
                            value: configLocal.value.oneAndHalfYear
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                        _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (0, vue_2.createElementVNode)("label", _hoisted_8, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitTwoHalfData,
                            value: configLocal.value.twoAndHalfYears
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9),
                        _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                    (0, vue_2.createElementVNode)("label", _hoisted_11, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitThreeHalfData,
                            value: configLocal.value.threeAndHalfYears
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12),
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                    (0, vue_2.createElementVNode)("label", _hoisted_14, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitFourHalfData,
                            value: configLocal.value.fourAndHalfYears
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15),
                        _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                    (0, vue_2.createElementVNode)("label", _hoisted_17, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitFiveHalfData,
                            value: configLocal.value.fiveAndHalfYears
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18),
                        _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                    (0, vue_2.createElementVNode)("label", _hoisted_20, [
                        (0, vue_2.createElementVNode)("input", {
                            class: "form-input small",
                            type: "number",
                            min: "0",
                            placeholder: "1",
                            onInput: emitSixHalfData,
                            value: configLocal.value.sixAndHalfYears
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21),
                        _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("span", null, "日", -1 /* CACHED */))
                    ])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
